import { StakingErc3643StatusApi, StakingErc3643TxTypeApi } from 'Modules'

import { PoolStatus, PoolTransactionType } from 'pages/staking-erc-3643/types'

export const STAKING_ERC3643_STATUS_FROM_API: Record<StakingErc3643StatusApi, PoolStatus> = {
  SCHEDULED: 'Scheduled',
  ACTIVE: 'Active',
  ENDED: 'Ended',
}

export const STAKING_ERC3643_STATUS_TO_API: Record<PoolStatus, StakingErc3643StatusApi> = {
  Scheduled: 'SCHEDULED',
  Active: 'ACTIVE',
  Ended: 'ENDED',
}

export const STAKING_ERC3643_TX_FROM_API: Record<StakingErc3643TxTypeApi, PoolTransactionType> = {
  STAKE: 'Stake',
  UNSTAKE: 'Unstake',
  CLAIM: 'Claim rewards',
}

export const STAKING_ERC3643_TX_TO_API: Record<PoolTransactionType, StakingErc3643TxTypeApi> = {
  Stake: 'STAKE',
  Unstake: 'UNSTAKE',
  'Claim rewards': 'CLAIM',
}
